module.exports = __webpack_public_path__ + "static/Cristina-888e71dc8383ad8e0dfe7dcd8d52df01.jpg";